export default "__VITE_ASSET__0UbdJCvy__"